import { FormatValue } from '../types';

import { MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES } from 'app/constants/userRestrictions';
import { isSupportedLang } from 'app/lang';
import { FALLBACK_LANG, I18Lang } from 'app/lang/constants';

import { formatNumber } from '../formatNumber';
import { DELIMITERS_BY_LANG } from '../utils';

export const formatMoney = (
  value: FormatValue,
  lang: I18Lang,
  useMathParse = true,
  decimals = MAX_POSSIBLE_NUMBER_OF_DECIMAL_PLACES,
): string => {
  const options = isSupportedLang(lang)
    ? DELIMITERS_BY_LANG[lang]
    : DELIMITERS_BY_LANG[FALLBACK_LANG];

  return formatNumber(value, {
    skipTruncate: false,
    decimalPoint: options.decimal,
    thousandsSeparator: options.thousands,
    decimals,
    useMathParse,
  });
};

